import { render, staticRenderFns } from "./OrderAddresses.vue?vue&type=template&id=01f5a245&"
import script from "./OrderAddresses.vue?vue&type=script&lang=js&"
export * from "./OrderAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports